import {
  HomeIcon,
  MapPinIcon,
  ChartBarIcon,
  Cog6ToothIcon,
  BeakerIcon,
} from '@heroicons/react/24/outline';
import type { ProductConfig } from '../registry';

export default {
  slug: 'pounce',
  icon: BeakerIcon,
  accentColor: {
    bg: 'bg-cyan-500/10',
    border: 'border-cyan-500/30',
    text: 'text-cyan-400',
  },
  navigation: [
    { name: 'DASHBOARD', href: '/pounce/dashboard', icon: HomeIcon },
    { name: 'INCIDENTS', href: '/pounce/incidents', icon: MapPinIcon },
    { name: 'RESPONSE', href: '/pounce/response', icon: ChartBarIcon },
    { name: 'SETTINGS', href: '/pounce/settings', icon: Cog6ToothIcon },
  ],
  landingPage: '/pounce/dashboard',
} satisfies ProductConfig;
